module.exports = "https://coursera_assets.s3.amazonaws.com/images/f93d412349e801238d46a2b167695c43.png";